module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
  "use strict";

  var _ = {
    mixBigThumb: function () {
      var fsv = this.rwom1("#fullscreenView");

      return fsv.mixBigThumb.apply(fsv, arguments);
    },
  };

  fox.registerWidget(
    "MC_Photoset_Gallery",
    {
      configure: function () {
        this.bigThumb = [];
        this.previewThumb = [];

        this.registerOptions("", {
          template: "sitepage_Gallery",
          autoRender: true,
          amountInRow: 4,
          itemRightMargin: 4,
          minItemInRow: 2,
          widthsConfig: [
            { dWidth: 1050, amountInRow: 4 },
            { dWidth: 770, amountInRow: 3 },
            { dWidth: 600, amountInRow: 2 },
            { dWidth: 380, amountInRow: 1 },
          ],
          widgets: {
            fullscreenView: {
              widget: "FullscreenView",
            },
            photoset: {
              widget: "Content_Browser",
              container: ".main-block",
              externalLoad: true,
              preset: "gallery",
              list: {
                manualRender: true,
                "tpl.row": "sitepage_gallery_container",
                handleDom: {
                  showTag: {
                    target: ".toggle-tag",
                    event: "click",
                    callback: "@parent @parent:_toggleTag",
                  },
                },
              },
              "widgets.dl": {
                widget: "Datalayer",
                limit: 1,
                metaFields: {
                  zip: 1,
                },
                fields: [
                  "id",
                  "_resources.timeline.url",
                  "_resources.current.url",
                  "contentType",
                  "_zip",
                ],
              },
            },
            photoList: {
              widget: "List",
              group: "photolist",
              "embed.container": "#gallery-cut",
              "embed.widget": "@parent #photoset #list",
              "tpl.row": "sitepage_gallery_photolist_item",
              autoRender: false,
              "hooks.onStopRendering": this.photoListOnStopRendering,
              handleWom: {
                parentAddToDom: {
                  event: "addedToDom",
                  widget: "@parent #photoset #list",
                  callback: fox.bind(function (p, scope) {
                    if (this.previewThumb.length <= this.amountInRow * 3) {
                      $(this.dom1("#show-all-photos")).hide();

                      return this.renderPhotoList(this.previewThumb);
                    }

                    this.renderPhotoList(
                      this.previewThumb.slice(0, this.amountInRow * 3)
                    );
                  }, this),
                },
              },
            },
            photosetListAll: {
              widget: "List",
              group: "photolist",
              "embed.container": "#gallery-all",
              "embed.widget": "@parent #photoset #list",
              "tpl.row": "sitepage_gallery_photolist_item",
              autoRender: false,
              "hooks.onStopRendering": this.photoListOnStopRendering,
            },
            currentRating: {
              widget: "Social_Rating",
              targetDl: "@parent #photoset #dl",
              targetField: "id",
              "embed.widget": "@parent #photoset #list",
            },
            galleryComments: {
              showComments: true,
              widget: "Social_Comments",
              targetDl: "@parent #photoset #dl",
              template: "social_comment_scene",
              "embed.widget": "@parent #photoset #list",
              "handleDom.toggleForm": {
                targetWidget: "@parent #photoset #list",
              },
            },
            downloadButton: {
              widget: "Widget",
              "embed.container": ".download-block",
              "embed.widget": "@parent #photoset #list",
              autoRender: false,
              "hooks.onStartRendering": function () {
                var embedWidget = this.wom1(this.getOption("embed.widget"));
                var dl = this.wom1("@parent #photoset #dl");
                var downloadAccess = window.parseInt(
                  dl.getObjectValue("accessibility.downloadable")
                );
                var contentType = dl.getObjectValue("contentType");

                if (!downloadAccess) {
                  return false;
                } else {
                  var zip = dl.getObjectValue("_zip");
                  if (!fox.isEmpty(zip) && zip !== "[error]") {
                    this.setTemplateOptions({ _zip: zip });
                    this.setOption("template", "photo_download");
                  } else {
                    this.setOption("template", "");
                  }
                }
              },
            },
          },
          handleWom: {
            photosetLoaded: {
              event: "loaded",
              widget: "#photoset #dl",
              callback: "photosetLoaded",
            },
            listenNavi: {
              event: "modified_1",
              widget: "@root #navi",
              callback: "photosetChanged",
              "params.listenHistory": true,
              "params.alwaysActive": true,
            },
          },
          handleDom: {
            showAllPhotos: {
              event: "click",
              target: "#show-all-photos",
              targetWidget: "#photoset #list",
              callback: "showAllPhotos",
            },
            handlePrevClick: {
              event: "click",
              target: ".photo-item",
              targetWidget: ".List",
              callback: "showFullscreen",
            },
            handleDownload: {
              event: "click",
              target: ".photoset-download",
              targetWidget: "#photoset #list",
              callback: "logDownloadEvent",
            },
          },
        });

        if (fox.site.member) {
          this.registerOptions("", {
            widgets: {
              favorite: {
                widget: "Social_Favorite",
                targetDl: "@parent #photoset #dl",
                targetField: "id",
                "embed.widget": "@parent #photoset #list",
              },
            },
          });
        }

        this.callParent("configure", arguments);
      },

      init: function () {
        this.setListConfig();
        this.callParent("init", arguments);
      },

      activate: function (params) {
        $(window).bind("orientationchange", fox.bind(this.onResize, this));

        this.callParent("activate", arguments);

        this.setPid(params.id);
        this.setPageAlias(fox.Navigator.get(0));
      },

      setPageAlias: function (alias) {
        this.pageAlias = alias;
      },

      getPageAlias: function () {
        return this.pageAlias;
      },

      photosetChanged: function (id, nav) {
        if (this.getPageAlias() !== nav.get(0)) {
          return;
        }
        if (!fox.isEmpty(id) && this.isActive() && this.isEmbedded()) {
          this.setPid(parseInt(id));
        }
      },

      setPid: function (id) {
        this.pid = id;

        this.getPhotoset(this.pid);

        return this;
      },

      onResize: function (e) {
        clearTimeout(this.resizeTimeout);

        this.resizeTimeout = setTimeout(
          fox.bind(function () {
            fox.each(
              this.getWidgetsByGroup("photolist"),
              function (w, alias) {
                if (w.isEmbedded()) {
                  if (alias === "photosetListAll") {
                    w._readyToRender = true;
                    w._readyToEmbed = true;

                    w.wait("addedToDom").then(function () {
                      w._readyToRender = false;
                      w._readyToEmbed = false;
                    });
                  }

                  w.render();
                }
              },
              this
            );
          }, this),
          300
        );
      },

      deactivate: function () {
        $(window).unbind("onorientationchange", fox.bind(this.onResize, this));
        this.rwom1("#fullscreenView").hide();
        return this.callParent("deactivate", arguments);
      },

      getPhotoset: function (id) {
        var dl = this.rwom1("#photoset #dl");

        if (
          this.rwom1("#photoset #list").getOption("manualRender") === true ||
          dl.getObjectValue("id") !== parseInt(id)
        ) {
          dl.addFilter("id", ["id"], [id]).load();
        }
      },

      photosetLoaded: function (o, dl) {
        var r = dl.getCollection()[0]._resources;
        this.setTitle(dl);
        $("body, html").animate(
          {
            scrollTop: $(this.element).offset().top - 50,
          },
          500
        );

        this.originThumb = r.originThumb.filter(function (item) {
          return !!item.url;
        });
        this.bigThumb = _.mixBigThumb
          .call(this, r.bigThumb, r.originThumb)
          .filter(function (item) {
            return !!item.url;
          });
        this.previewThumb = dl
          .getCollection()[0]
          ._resources.previewThumb.filter(function (item) {
            return !!item.url;
          })
          .sort(function (a, b) {
            return a.position < b.position
              ? -1
              : a.position > b.position
              ? 1
              : 0;
          });
        this.allowDonwload = window.parseInt(
          dl.getObjectValue("accessibility.downloadable")
        );
      },

      renderMainContainer: function () {
        var w = this.rwom1("#photoset #list");

        w._readyToRender = true;
        w._readyToEmbed = true;

        w.render();

        this.waitEvent(w, "addedToDom", function () {
          w._readyToRender = false;
          w._readyToEmbed = false;
        });
      },

      renderPhotoList: function (c) {
        this.rwom1("#photoList").setCollection(c, true);
        var downloadButton = this.wom1("#downloadButton");
        downloadButton.render();
      },

      setListConfig: function () {
        var config = {},
          docW = $(document).width(),
          maxWidth;

        fox.each(
          this.getOption("widthsConfig"),
          function (v) {
            if (maxWidth === undefined || maxWidth < v.dWidth) {
              maxWidth = v.dWidth;
            }

            if (v.hasOwnProperty("dWidth") && v.hasOwnProperty("amountInRow")) {
              if (docW < v.dWidth) {
                this.amountInRow = v.amountInRow;

                if (v.hasOwnProperty("itemRightMargin")) {
                  this.itemMargin = v.itemRightMargin;
                } else {
                  this.itemMargin = this.getOption("itemRightMargin");
                }
              }
            }
          },
          this
        );

        if (docW > maxWidth) {
          this.amountInRow = this.getOption("amountInRow");
          this.itemMargin = this.getOption("itemRightMargin");
        }
      },

      photoListOnStopRendering: function () {
        var l = this,
          parent = l.getParent(),
          mir = parent.getOption("minItemInRow"),
          cw,
          tempC = [],
          air,
          docW = $(document).width(),
          buildImagesRow,
          getContainerWidth,
          itemMargin;

        parent.setListConfig();

        air = parent.amountInRow;
        itemMargin = parent.itemMargin;

        getContainerWidth = function () {
          var width,
            $body = $(document.body);

          $body.css("overflow", "scroll");
          width = $(l.getOption("embed.container")).width();
          $body.css("overflow", "inherit");

          return width;
        };

        cw = getContainerWidth();

        buildImagesRow = function (row, air, containerWidth) {
          // TIME TO WUDOO MAGIC )))

          var tempH = 0,
            tempW = 0,
            averageH,
            getImgAspectRatio;

          getImgAspectRatio = function (o) {
            return parseInt(o.info.width) / parseInt(o.info.height);
          };

          averageH =
            containerWidth /
            row.reduce(function (a, v, indx, array) {
              if (indx === 1) {
                a = getImgAspectRatio(a);
              }

              return a + getImgAspectRatio(v);
            });

          if (row.length === 1 && air === 1) {
            averageH = containerWidth / getImgAspectRatio(row[0]);
          }

          fox.each(row, function (v, indx) {
            var itemW = averageH * getImgAspectRatio(v),
              $img = $(l.dom1(["#photo-", v.id, " img"].join(""))).css(
                "visibility",
                "hidden"
              ),
              handleImage;

            handleImage = function (event) {
              var showImg, imgDiffLine, imgLoadError;

              if (event.type === "error") {
                imgLoadError = true;
              }

              imgDiffLine = function () {
                if (
                  $img.parent().offset().top <
                  $(window).height() + $(document).scrollTop()
                ) {
                  return true;
                } else {
                  return false;
                }
              };

              showImg = function (delay) {
                var f, delayInterval;

                f = function () {
                  //console.log($img, imgLoadError);
                  if (imgLoadError === true) {
                    $img.parent().addClass("img-load-error");
                  } else {
                    $img.css("visibility", "visible");
                  }

                  $img.parent().addClass("fadeInDown");

                  setTimeout(function () {
                    $img.parent().removeClass("fadeInDown");
                  }, 1010);
                };

                if (!delay) {
                  f();
                } else if (delay === true) {
                  delayInterval = Math.floor(Math.random() * (400 - 200)) + 200;

                  setTimeout(f, delayInterval);
                }
              };

              if (imgDiffLine()) {
                showImg();
              } else {
                fox.dom.on("scroll", document, function () {
                  if (!$img.data("noMoreScroll") && imgDiffLine()) {
                    showImg(true);

                    $img.data("noMoreScroll", true);
                  }
                });
                fox.dom.on("touchmove", document, function () {
                  if (!$img.data("noMoreScroll") && imgDiffLine()) {
                    showImg(true);

                    $img.data("noMoreScroll", true);
                  }
                });
              }
            };

            fox.dom.on("load", $img.get(0), handleImage);
            fox.dom.on("error", $img.get(0), handleImage);

            $img
              .parent()
              .width(indx === row.length - 1 ? Math.floor(itemW) : itemW);
            $img.parent().height(averageH);

            if (indx !== row.length - 1) {
              $img.parent().css("marginRight", itemMargin);
            }
          });
        };

        for (
          var j = 0, i = 0;
          i < Math.ceil(l.collection.length / air);
          i++, j += air
        ) {
          tempC.push(l.collection.slice(j, j + air));
        }

        if (tempC.length > 2 && tempC[tempC.length - 1].length < mir) {
          tempC[tempC.length - 2] = tempC[tempC.length - 2].concat(tempC.pop());
        }

        fox.each(
          tempC,
          function (val, indx) {
            var diffMargin = 0;

            if (val.length > 1) {
              diffMargin = itemMargin * (val.length - 1);
            }

            buildImagesRow(val, air, cw - diffMargin);
          },
          this
        );
      },

      showAllPhotos: function (el) {
        var l = this.rwom1("#photosetListAll");

        l._readyToRender = true;
        l._readyToEmbed = true;
        l.setCollection(this.previewThumb.slice(this.amountInRow * 3));
        this.waitEvent(l, "addedToDom", function () {
          l._readyToRender = false;
          l._readyToEmbed = false;
        });

        $(el).hide();
      },

      getImgById: function (id, c) {
        if (fox.isArray(c)) {
          return c
            .filter(function (value, index) {
              return Number(value.id) === Number(id);
            })
            .pop();
        }

        return false;
      },

      showFullscreen: function (e) {
        var id = $(e).data("id"),
          photoData = this.getImgById(id, this.bigThumb);

        if (photoData) {
          this.rwom1("#fullscreenView")
            .setPhotoCollection(
              this.bigThumb,
              this.originThumb,
              this.previewThumb
            )
            .setCurrentPhoto(photoData)
            .show({
              allowDownload: this.allowDonwload,
            });
        }
      },

      logDownloadEvent: function (e) {
        var api = new fox.Api(null, this._wom).method("logger.log");
        api.send(
          {
            index: "McUserActivity",
            path: fox.Navigator.getAll(),
            info: { event: "download" },
          },
          false
        );
      },

      getContentId: function () {
        return this.pid;
      },

      setTitle: function (data) {
        var collection = data.getCollection()[0];
        var metaDescription = fox.dom.selectFirst('meta[name="description"]');
        var nav = decodeURIComponent(fox.Navigator.get(2));
        var parseTitle = nav === "false" ? collection.title : nav;
        parseTitle = parseTitle.replace(/-/g, " ");
        document.title =
          parseTitle + " - Top Photos of " + fox.getEnv("screenName");
        collection.description !== ""
          ? metaDescription.setAttribute("content", collection.description)
          : metaDescription.setAttribute(
              "content",
              fox.getEnv("screenName") +
                " High-quality Photo Gallery Images " +
                parseTitle +
                ". Download photos or share to Facebook, Twitter, Tumblr, and Blogger."
            );
      },
      _toggleTag: function (el) {
        $(el).parent().parent().find(".tags").toggleClass("open-more");
      },
    },
    "Site_Page"
  );
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/mcPhotosetGallery.js
// module id = 904
// module chunks = 4